export const SUPPORTED_FUNCTIONS = ["sqrt", "cos", "sin", "tg", "bignumber"];
export const SUPPORTED_CHARACTERS = ["°", "`"];
export const MATRIX_LATEX = "\\begin{pmatrix}";
